import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-modern-circular-progress',
  templateUrl: './modern-circular-progress.component.html',
  styleUrls: ['./modern-circular-progress.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class ModernCircularProgressComponent implements OnInit, OnChanges {
  @Input() value: number = 0;
  @Input() size: number = 60;
  @Input() strokeWidth: number = 4;
  @Input() showPercentage: boolean = true;
  @Input() color: string = '#756ef3';
  @Input() backgroundColor: string = '#f0f0f0';
  @Input() animationDuration: number = 1000;

  circumference: number = 0;
  strokeDasharray: string = '';
  strokeDashoffset: string = '';
  radius: number = 0;

  constructor() { }

  ngOnInit(): void {
    this.calculateCircle();
  }

  ngOnChanges(): void {
    this.calculateCircle();
  }

  private calculateCircle(): void {
    this.radius = (this.size - this.strokeWidth) / 2;
    this.circumference = 2 * Math.PI * this.radius;
    this.strokeDasharray = `${this.circumference}`;
    
    const progress = Math.min(Math.max(this.value, 0), 100);
    const offset = this.circumference - (progress / 100) * this.circumference;
    this.strokeDashoffset = `${offset}`;
  }

  get viewBox(): string {
    return `0 0 ${this.size} ${this.size}`;
  }

  get center(): number {
    return this.size / 2;
  }

  get fontSize(): number {
    return Math.max(this.size * 0.24, 9);
  }
}
